import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { LocationState } from '../types/Base.types';

const useGoBackUrl = (path: string) => {
  const location = useLocation<LocationState>();

  const goBackUrl = useMemo(() => {
    if (location.state?.filters && location.state?.originUrl === path) {
      return `${path}${location.state?.filters}`;
    }
    return path;
  }, [location.state?.filters, location.state?.originUrl, path]);

  return goBackUrl;
};

export default useGoBackUrl;
